import { Button, FormControl, Input, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import PageContainer from '../../components/pageContainer/PageContainer';
import { handleResetPassword } from '../../slice/resetPasswordSlice';

function Contact() {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [email, setEmail] = useState('');
  const [isSuccessful, setIsSuccessful] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setDisabled(true);

    const res = (await dispatch(handleResetPassword(email))).payload;
    if (res.ok) {
      setIsSuccessful(true);
    } else {
      setDisabled(false);
    }
  };

  return isSuccessful
    ? (
        <PageContainer>
          <Text fontSize={20} fontWeight={400}>
            A new password has been sent to your email
          </Text>
        </PageContainer>
      )
    : (
        <PageContainer>
          <Text color='#377DFF' fontSize='xl' fontWeight={500}>Enter your account email below</Text>
          <form onSubmit={handleSubmit} disabled={disabled}>
            <FormControl margin='10px 0' isRequired>
              <Input w='300px' value={email} onChange={e => setEmail(e.target.value)} placeholder='Email'/>
            </FormControl>
            <Button margin='10px 0' backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9', color: 'whitesmoke' }} type='submit'>Submit</Button>
          </form>
        </PageContainer>
      );
}

export default Contact;
